import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useTranslations} from './';

const defaultTranslations = {
    adultText: 'Adult',
    adultsText: 'Adults',
    childText: 'Child',
    childrenText: 'Children',
    guestText: 'Guest',
    guestsText: 'Guests',
    petsText: 'Pets',
    label: 'Guests',
    guestLabel: undef,
    modalTitle: 'Select guests',
    adultsLabel: undef,
    childrenLabel: undef,
    petLabel: 'Pets',
    petNoLabel: 'No',
    petYesLabel: 'Yes',
    petMessage: 'Only properties that allow pets will be shown',
    applyButtonLabel: 'Apply',
    clearButtonLabel: 'Clear',
    continueButtonLabel: 'Continue'
};

function useGuestsTranslations(props) {
    const {
        guestsTranslations: propsTranslations
    } = props;

    const {
        translations
    } = useTranslations(defaultTranslations, propsTranslations);

    const result = {
        translations
    };

    useDebugValue(result);

    return result;
}

export {useGuestsTranslations};
